import React from 'react';
import { SkeletonRegistryItem } from '../../../registry/skeleton/SkeletonRegistryItem';
import { SkeletonRegistryCategory } from '../../../registry/skeleton/SkeletonRegistryCategory';
import { Aspect_ } from '../../../components/actor/Aspect_';
import { Actor_ } from '../../../components/actor/Actor_';
export class SkeletonsOrderedChoice extends SkeletonRegistryCategory {
    label = 'OrderedChoice';
    constructor(parent) {
        super(parent);
        super.init();
    }
    draftOrderedChoiceStructure_base = () => new SkeletonRegistryItem({
        label: 'Base OrderedChoice Structure',
        jsx: ({ question }) => {
            if (!question)
                return null;
            const question_ = question;
            if (!question_.orderedTask.step)
                return null;
            return React.createElement(Actor_, { actor: question_.orderedTask.step });
        },
    });
    draftOrderedChoiceStepStructure_optionsBoxed = () => new SkeletonRegistryItem({
        label: 'Step Structure Options Boxed',
        jsx: ({ step }) => {
            if (!step)
                return null;
            const orderedStep = step;
            return (React.createElement(Aspect_, { aspect: orderedStep.question.inner },
                React.createElement(Actor_, { actor: orderedStep.question.questionPart }),
                React.createElement(Aspect_, { aspect: orderedStep.ownAspect.options }, orderedStep.task.shuffledOptions
                    .filter(option => !option.shouldHideInStepOptionList)
                    .map(option => (React.createElement(Actor_, { actor: option, key: option.tid })))),
                orderedStep.task.steps.map(s => (React.createElement(Aspect_, { aspect: s.ownAspect.feedback, key: s.id })))));
        },
    });
    draftOrderedChoiceStepStructure_optionsAbsolute = () => new SkeletonRegistryItem({
        label: 'Step Structure Options Absolute',
        jsx: ({ step }) => {
            if (!step)
                return null;
            const orderedStep = step;
            return (React.createElement(Aspect_, { aspect: orderedStep.question.inner },
                React.createElement(Actor_, { actor: orderedStep.question.questionPart }),
                orderedStep.task.shuffledOptions
                    .filter(option => !option.shouldHideInStepOptionList)
                    .map(option => (React.createElement(Actor_, { actor: option, key: option.tid }))),
                orderedStep.task.steps.map(s => (React.createElement(Aspect_, { aspect: s.ownAspect.feedback, key: s.id })))));
        },
    });
    orderedChoiceNthGapFill = () => new SkeletonRegistryItem({
        label: 'Corresponsing Step in Rolename Fill',
        jsx: ({ at, orderedTask, question, gap }) => {
            if (!orderedTask || !question || !gap || !orderedTask.steps)
                return null;
            const stepName = at.actor.tags.find(role => role.includes('step'));
            if (!stepName)
                return false;
            const nth = parseInt(stepName.split('step')[1]);
            if (orderedTask.steps.length < nth)
                return null;
            const option = orderedTask.steps[nth - 1].correctOption;
            if (!option)
                return null;
            if (at.trait.local.valueOf.contentFillType === 'textBasis') {
                return option.actorContent.local.firstTextBasis;
            }
            return React.createElement(Actor_, { actor: option, key: option.tid });
        },
        params: { core: ['contentFillType'] },
    });
}
